import { EnumTipoNavio } from "../../Model/Estimativa/EnumTipoNavio";
export class InformacaoPortuariaBasicaDTO {
    constructor() {
        this.TipoOperacao = null;
        this.DataAtracacao = new Date();
        this.DataDesatracacao = new Date();
        this.QtdEmbarqueVazio = 0;
        this.QtdEmbarqueCheio = 0;
        this.QtdDescargaCheio = 0;
        this.QtdDescargaVazio = 0;
        this.QtdRemocaoBordoCheio = 0;
        this.QtdRemocaoBordoVazio = 0;
        this.QtdRemocaoCaisCheio = 0;
        this.QtdRemocaoCaisVazio = 0;
        this.QtdEmbarqueTransbordo = 0;
        this.QtdDescargaTransbordo = 0;
        this.QtdMovimentacaoTampa = 0;
        this.TamanhoEmbarcacao = 0;
        this.Tonelagem = 0;
        this.TipoNavio = EnumTipoNavio.LONGOCURSO;
    }
}
